import {
  getApiV1ThreeLetterCodePartnerAdminsTopBannersId,
  getGetApiV1ThreeLetterCodePartnerAdminsTopBannersIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsTopBannersId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** トップバナーID */
  topBannerId: number;
};

type ReturnType = {
  /** トップバナーデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsTopBannersId200;
};

/**
 * useGetPartnerAdminsTopBannerフックの型定義
 */
type IUseGetPartnerAdminsTopBanner = (args: Args) => ReturnType;

/**
 * パートナー管理者用トップバナー詳細取得フック
 * Suspenseを使用してデータを取得
 */
export const useGetPartnerAdminsTopBanner: IUseGetPartnerAdminsTopBanner = ({
  threeLetterCode,
  topBannerId,
}) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsTopBannersIdKey(threeLetterCode, topBannerId),
    () => getApiV1ThreeLetterCodePartnerAdminsTopBannersId(threeLetterCode, topBannerId),
    { suspense: true }
  );

  return {
    data,
  };
};
